import { memo } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

/* Internal /drift links route in-app; everything else opens in a new tab. */
const A = ({ href = "", children, ...rest }) => {
  if (href.startsWith("/drift")) return <Link to={href} {...rest}>{children}</Link>;
  return <a href={href} target="_blank" rel="noreferrer" {...rest}>{children}</a>;
};
const Table = ({ children }) => <div className="overflow-x-auto"><table>{children}</table></div>;

export const Markdown = memo(function Markdown({ text, className, doc = false }) {
  return (
    <div className={cn("md", doc && "md-doc", className)}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ a: A, table: Table }}>{text || ""}</ReactMarkdown>
    </div>
  );
});
